<template>
  <va-create-layout>
    <specialties-form :title="title" :item="item"></specialties-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ["title", "item"],
};
</script>
